import React, { useEffect, useRef, useState } from 'react';
import * as styles from './TrustmateWidget.module.scss';
// Użyte do oznaczenia, że dany skrypt już jest w DOM
const SCRIPT_DATA_ATTR = 'data-trustmate-widget-script';
const TrustmateWidget = ({
  widgetId,
  scriptSrc = '',
  lazy = true,
  onLoad
}) => {
  const containerRef = useRef(null);
  const {
    0: loaded,
    1: setLoaded
  } = useState(false);
  const resolvedScriptSrc = scriptSrc || `https://trustmate.io/widget/api/${widgetId}/script`;

  // Wstrzyknięcie skryptu do <head>, tylko raz per widgetId
  const injectScript = () => {
    if (typeof window === 'undefined' || loaded) return;
    const existing = document.querySelector(`script[${SCRIPT_DATA_ATTR}="${widgetId}"]`);
    if (existing) {
      setLoaded(true);
      onLoad === null || onLoad === void 0 ? void 0 : onLoad();
      return;
    }
    const s = document.createElement('script');
    s.src = resolvedScriptSrc;
    s.defer = true;
    s.setAttribute(SCRIPT_DATA_ATTR, widgetId);
    s.addEventListener('load', () => {
      setLoaded(true);
      onLoad === null || onLoad === void 0 ? void 0 : onLoad();
    });
    document.head.appendChild(s);
  };
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!lazy) {
      injectScript();
      return;
    }
    const el = containerRef.current;
    if (!el) return;

    // Lazy: ładuj dopiero gdy kontener wejdzie w viewport
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          injectScript();
          io.disconnect();
        }
      });
    }, {
      rootMargin: '200px'
    });
    io.observe(el);
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgetId, resolvedScriptSrc, lazy]);
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    id: widgetId,
    className: styles.rootContainer,
    "aria-busy": !loaded,
    "aria-live": "polite"
  }));
};
export default TrustmateWidget;